// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--2_O_l","wrapper1":"index-module--wrapper1--2LSvd","logo":"index-module--logo--2K91F","info":"index-module--info--2ZpSC"};